import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer id="contacts" className="site-footer">
            <div className="container">
                <div className="row g-4 justify-content-center text-md-center footer-row">
                    <div className="col-12 col-md-auto">
                        <h3 className="footer-h">Реквизиты организации</h3>
                        <ul className="footer-req">
                            <li><span>ИНН</span> 7709438132</li>
                            <li><span>КПП</span> 770901001</li>
                            <li><span>ОГРН</span> 1047746017725</li>
                        </ul>
                    </div>

                    <div className="col-12 col-md-auto">
                        <h3 className="footer-h">Контактная информация</h3>
                        <ul className="footer-contacts">
                            <li><a href="tel:+79161571131">📞 +7 (916) 157-11-31</a></li>
                            <li><a href="mailto:sodeystvie@gmail.com">✉️ sodeystvie@gmail.com</a></li>
                            <li><a href="mailto:info@org-sodeystvie.ru">✉️ info@org-sodeystvie.ru</a></li>
                            <li>
                                <a href="https://t.me/Veronika_Yakimenko" target="_blank" rel="noopener noreferrer">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71l-4.1-3.03-1.97 1.91c-.22.22-.4.4-.81.4z"/>
                                    </svg>
                                    Telegram
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <span>© {year} · Сделано с любовью <span className="heart">❤</span></span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
